import { EditorValue, initialValue } from 'components/TextEditor/types'
import useStorage from 'hooks/useStorage'

interface Option {
  value: string
  label: string
}

export interface Form {
  qrId?: string
  name: string
  birth: string
  death: string
  gps?: base.Coords
  biography: EditorValue
  sentence: string
  media: File[]
  showMaterials: boolean
  updateProfile: boolean
  selectedImage: File | null
  selectedOption: Option | null
}

export type UpdateFormValue = <T extends keyof Form>(key: T, value: Form[T]) => void
export type UpdateForm = (values: Partial<Form>) => void

export const PROFILE_STORAGE_KEY = 'profile_form'
const SESSION = true

const useForm = () => {
  const [form, setForm] = useStorage<Form>(
    {
      name: '',
      birth: '',
      death: '',
      sentence: '',
      biography: initialValue,
      selectedImage: null,
      selectedOption: null,
      showMaterials: false,
      updateProfile: false,
      media: [],
    },
    PROFILE_STORAGE_KEY,
    SESSION
  )

  const updateFormValue: UpdateFormValue = (key, value) => {
    setForm(prev => ({
      ...prev,
      [key]: value
    }))
  }

  const updateForm: UpdateForm = (values) => {
    setForm(prev => ({
      ...prev,
      ...values
    }))
  }

  return [
    form,
    updateFormValue,
    updateForm
  ] as const
}

export default useForm